import { orchestrator } from 'satcheljs';
import {
    getUpNextCalendarEventWithOnlineJoinableEvents,
    isUpNextScenarioInitialized,
} from 'owa-upnext-event-loader';
import { loadFullEvent } from 'owa-calendar-events-loader';
import { getLockId } from '../selectors/getLockId';
import { isValidOnlineMeeting } from 'owa-online-meeting/lib/bootIndex';
import { observableNowChanged } from 'owa-observable-datetime';

orchestrator(observableNowChanged, () => {
    const lockId = getLockId();
    if (isUpNextScenarioInitialized(lockId)) {
        const {
            upNextEvent,
            eventsWithinUpNextEvent,
        } = getUpNextCalendarEventWithOnlineJoinableEvents(lockId);

        if (upNextEvent) {
            if (!isValidOnlineMeeting(upNextEvent, true)) {
                loadFullEvent(lockId, upNextEvent.ItemId);
            }

            if (eventsWithinUpNextEvent) {
                for (let i = 0; i < eventsWithinUpNextEvent.length; i++) {
                    if (!isValidOnlineMeeting(eventsWithinUpNextEvent[i], true)) {
                        loadFullEvent(lockId, eventsWithinUpNextEvent[i].ItemId);
                    }
                }
            }
        }
    }
});
